import axios, { AxiosRequestConfig } from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import { csrfHandler, setCSRFToken } from "./handler/csrfHandler";
declare const currentContextPath: string;

const HTTP_PRECONDITION_FAILED = 412;

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
	__retryCount: number;
}

export const $axios = axios.create({
	baseURL: currentContextPath,
} as AxiosRequestConfig);

export const $axiosRefresh = axios.create({
	baseURL: currentContextPath,
} as AxiosRequestConfig);

createAuthRefreshInterceptor($axios, csrfHandler, {
	statusCodes: [HTTP_PRECONDITION_FAILED],
	pauseInstanceWhileRefreshing: true,
	retryInstance: $axiosRefresh,
});

$axios.interceptors.request.use((config) => {
    (config as any).__retryCount = (config as any).__retryCount || 0;
	return config;
});

$axios.interceptors.response.use(
	(response) => response,
	// eslint-disable-next-line complexity
	async (error) => {
		const config = error.config as CustomAxiosRequestConfig;
		const token = error.response?.headers["csrftoken"];
		token && setCSRFToken(token);
		if (config && config.headers && token) {
			config.headers["CSRFToken"] = token;
		}

		if (config && error.response && error.response.status === HTTP_PRECONDITION_FAILED && config.__retryCount < 3) {
			config.__retryCount += 1;
			// Retry the request
			return $axios(config);
		}
		return Promise.reject(error);
	}
);
